import Layout from "../../components/Layout";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { InputMask } from "@react-input/mask";

const Producers = () => {
  return (
    <Layout>
      <div className="user-modal-inputs">
        <Form>
          <Form.Group>
            <label className="mb-2">Üretici Ünvanı</label>
            <Form.Control type="text" placeholder="" />
          </Form.Group>

          <Form.Group>
            <label className="mb-2">Üretici Markaları:</label>
            <Form.Control type="text" placeholder="" />
          </Form.Group>

          <Form.Group>
            <label className="mb-2">Üretici Kontak Kişi Ad Soyad:</label>
            <Form.Control type="text" placeholder="" />
          </Form.Group>

          <Form.Group>
            <label className="mb-2">Üretici Kontak Kişi Mail:</label>
            <Form.Control type="text" placeholder="" />
          </Form.Group>

          <Form.Group>
            <label className="mb-2">Üretici Kontak Kişi Telefon:</label>
            <InputMask
              mask="+90__________"
              replacement={{ _: /\d/ }}
              className="form-control"
              placeholder="Telefon No Giriniz:"
              showMask
            />
          </Form.Group>

          <div className="button-wrapper">
            <Button variant="danger">
              Distribütörlük Sözleşmesi Görüntüle
            </Button>
            <Button variant="secondary">İptal</Button>
            <Button variant="primary">Kaydet</Button>
          </div>
        </Form>
      </div>
    </Layout>
  );
};

export default Producers;
